import { ecId, record } from '../janus-engine/ability/context.js';
import { normalizePhpListish } from '../shared/php-listish.js';
import { actorEncounterFor } from './movement-truth.js';
import type { AppliedFrameResult } from '../janus-engine/transport/applied-frame.js';

/** Retire only departed members; row-patch subscribers clear their scene objects and target picks. */
export function retireEncounterCreatures(encounterId: string, ids: Iterable<string>): void {
  const requested = new Set(ids), encounter = actorEncounterFor(encounterId);
  if (!encounter || !requested.size) return;
  const roster = normalizePhpListish(encounter.encounter_creatures_arr), removed = new Set<string>();
  for (let index = roster.length - 1; index >= 0; index--) {
    const id = ecId(record(roster[index]));
    if (!requested.has(id)) continue;
    roster.splice(index, 1);
    removed.add(id);
  }
  if (removed.size && roster !== encounter.encounter_creatures_arr) encounter.encounter_creatures_arr = roster;
  for (const id of requested) if (window.FateTide?.casterCache?.delete(id)) removed.add(id);
  if (!removed.size) return;
  window.dispatchEvent(new CustomEvent('ft:encounter-rows-patched', { detail: { encounterId, removedIds: [...removed] } }));
  (window as Window & { ftAbilityTargetingRefreshCandidates?: () => void }).ftAbilityTargetingRefreshCandidates?.();
}

// Both the initiating page and peers receive this before their applied roster
// drops the row. Retire its cache/scene/picks together while the identity is held.
window.addEventListener('ft:truth-frame-applied', event => {
  const frame = (event as CustomEvent<AppliedFrameResult>).detail;
  if ('cache_ref' in frame) return;
  retireEncounterCreatures(frame.encounter_id, frame.deletes
    .filter(row => row.table === 'encounter_creatures').map(row => row.row_id.toUpperCase()));
});
